import React from 'react';
export function Footer() {
  return <footer className="bg-dark-900 border-t border-dark-800 py-12 text-center" data-id="element-74">
      <div className="max-w-4xl mx-auto px-4" data-id="element-75">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-dark-800 border border-dark-700 mb-6" data-id="element-76">
          <span className="text-xl" data-id="element-77">🚀</span>
          <span className="text-sm font-bold tracking-widest text-gray-300 uppercase" data-id="element-78">
            CM DIGITAL PRO
          </span>
        </div>

        <p className="text-gray-400 mb-8" data-id="element-79">
          El sistema que convierte personas comunes en ingresos reales
        </p>

        <div className="bg-dark-800/50 py-6 px-4 rounded-xl border border-dark-700/50 inline-block" data-id="element-80">
          <p className="text-xl md:text-2xl font-bold text-transparent bg-clip-text bg-gold-gradient italic" data-id="element-81">
            👉 "Tu primera venta puede estar a 7 días… o menos"
          </p>
        </div>

        <p className="text-xs text-gray-600 mt-12" data-id="element-82">
          © {new Date().getFullYear()} CM Digital Pro. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}